import { useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const CASHTAG = "$morrdanimorr";
export const CASHAPP_URL = "https://cash.app/$morrdanimorr";
export const QR_URL =
  "https://customer-assets-v7afamib.emergentagent.net/job_danimorr/artifacts/54a93240d3df0a3a_Screenshot_14-10-2026_181150_cash.app.jpeg";

export const useCoinCelebration = (soundOn = true) => {
  const [coins, setCoins] = useState([]);
  const [golden, setGolden] = useState(false);
  const [flash, setFlash] = useState(false);
  const audioRef = useRef(null);
  const soundRef = useRef(soundOn);
  soundRef.current = soundOn;

  const clink = (big) => {
    if (!soundRef.current) return;
    try {
      if (!audioRef.current) {
        audioRef.current = new (window.AudioContext || window.webkitAudioContext)();
      }
      const ctx = audioRef.current;
      const now = ctx.currentTime;
      const partials = big ? [5232, 7040, 4186, 3136, 6278] : [5232, 7040, 4186];
      partials.forEach((f, i) => {
        const o = ctx.createOscillator();
        const g = ctx.createGain();
        o.type = "sine";
        o.frequency.value = f;
        const t = now + i * 0.018;
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime((big ? 0.14 : 0.1) / (i + 1), t + 0.008);
        g.gain.exponentialRampToValueAtTime(0.0001, t + 0.3);
        o.connect(g);
        g.connect(ctx.destination);
        o.start(t);
        o.stop(t + 0.32);
      });
    } catch {}
  };

  const celebrate = (big = false) => {
    const count = big ? 34 : 16;
    const burst = Array.from({ length: count }, (_, i) => ({
      id: `${Date.now()}-${i}`,
      x: (Math.random() - 0.5) * (big ? 620 : 380),
      y: -(150 + Math.random() * (big ? 380 : 230)),
      rotate: Math.random() * 720 - 360,
      delay: Math.random() * (big ? 0.45 : 0.25),
      scale: (big ? 0.9 : 0.7) + Math.random() * (big ? 0.9 : 0.7),
    }));
    setCoins(burst);
    setGolden(big);
    setFlash(big);
    clink(big);
    setTimeout(
      () => {
        setCoins([]);
        setFlash(false);
      },
      big ? 3400 : 2700
    );
  };

  const layer = (
    <>
      <AnimatePresence>
        {flash && (
          <motion.span
            key="golden-flash"
            data-testid="golden-flash"
            aria-hidden="true"
            className="absolute left-1/2 top-16 -translate-x-1/2 w-44 h-44 rounded-full pointer-events-none z-40"
            style={{
              background:
                "radial-gradient(circle, rgba(232,200,122,0.55) 0%, rgba(193,140,61,0.2) 55%, transparent 72%)",
            }}
            initial={{ scale: 0.3, opacity: 0.9 }}
            animate={{ scale: 2.8, opacity: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.5, ease: "easeOut" }}
          />
        )}
      </AnimatePresence>
      <div className="pointer-events-none absolute inset-x-0 top-10 z-50 flex justify-center" aria-hidden="true">
        <AnimatePresence>
          {coins.map((c) => (
            <motion.span
              key={c.id}
              data-testid="coin"
              className={`coin absolute ${golden ? "coin-gold" : ""}`}
              initial={{ y: 0, x: 0, opacity: 1, rotate: 0, scale: c.scale }}
              animate={{ y: c.y, x: c.x, opacity: [1, 1, 1, 0], rotate: c.rotate }}
              exit={{ opacity: 0 }}
              transition={{ duration: golden ? 2.6 : 2, delay: c.delay, ease: [0.16, 0.8, 0.3, 1] }}
            >
              $
            </motion.span>
          ))}
        </AnimatePresence>
      </div>
    </>
  );

  return { celebrate, layer };
};
